// extracted by mini-css-extract-plugin
export default {"formHeading":"hL-z","form":"iL-z","submitBtn":"jL-z","disabled":"kL-z","input":"lL-z","error":"mL-z","submitMsg":"nL-z","signIn":"oL-z"};